import { render, staticRenderFns } from "./DiyNewDashboard.vue?vue&type=template&id=0a741627&scoped=true"
import script from "./DiyNewDashboard.vue?vue&type=script&lang=js"
export * from "./DiyNewDashboard.vue?vue&type=script&lang=js"
import style0 from "./DiyNewDashboard.vue?vue&type=style&index=0&id=0a741627&prod&scoped=true&lang=css"
import style1 from "./DiyNewDashboard.vue?vue&type=style&index=1&id=0a741627&prod&scoped=true&lang=css"
import style2 from "./DiyNewDashboard.vue?vue&type=style&index=2&id=0a741627&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a741627",
  null
  
)

export default component.exports